<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     物料存放位置
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="material-location">
    <f-search-input v-model="filterText" :placeholder="placeholder" />
    <div class="mt mb" @click="clickAll">全部</div>
    <el-tree
      class="filter-tree"
      :data="options"
      :props="defaultProps"
      :default-expand-all="false"
      :filter-node-method="filterNode"
      ref="tree"
      @node-click="nodeClick">
    </el-tree>
  </div>
</template>

<script>
import { bomGetfewApi } from '@/api/mes/bomApi'

export default {
  name: "MaterialLocation",

  props: {
    value: {
      type: Number,
      default: 0
    },

    placeholder: {
      type: String,
      default: '存放位置'
    }
  },

  data() {
    return {
      filterText: '',
      options: [
      {
        id: 1,
        label: '原料仓',
        children: [{
          id: 4,
          label: '标准件区'
        }, {
          id: 5,
          label: '非标准件区'
        }]
      }, {
        id: 2,
        label: '半成品仓',
        children: [{
          id: 6,
          label: 'A区-01'
        }, {
          id: 7,
          label: 'B区-01'
        }]
      }, {
        id: 3,
        label: '成品仓',
        children: [{
          id: 8,
          label: 'C区-01'
        }, {
          id: 9,
          label: 'D区-01'
        }]
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },

  computed: {
    location: {
      get() {
        return this.value ? this.value : null
      },
      set(val) {
        this.$emit('input', val ? val : null)
      }
    }
    
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },

  created() {
    // this.fetchData()
  },

  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    
    fetchData() {
      const query = {
        mfgid: this.mfgid
      }
      bomGetfewApi(query).then(res => {
        if (!res.errno) {
          this.options = res.data
        }
      })
    },

    clickAll() {
      this.$emit('change')
    },

    nodeClick(val) {
    },

  }
}
</script>

<style lang="scss" scoped>
  /deep/ .el-tree-node__content {
    height: 32px;
  }
  /deep/ .el-tree-node__content:hover {
    color: #07c160;
  }
  /deep/ .is-current {
    .el-tree-node__content {
      color: #07c160;
      // background-color: #F5F7FA;
    }
  }
</style>
